export const exams = 'exams'
export const courses = 'courses'